var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 60,
    viewBox: "0 0 67 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4378 3.50001C30.1321 -1.16666 36.8679 -1.16667 39.5622 3.5L65.9759 49.25C68.6702 53.9167 65.3024 59.75 59.9138 59.75H7.08624C1.69764 59.75 -1.67026 53.9167 1.02405 49.25L27.4378 3.50001Z",
    fill: "#F1F4FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.c67d5ba153cafe9ffe8b68af3d1c3ffb.svg";
export { ForwardRef as ReactComponent };